import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Popup } from 'react-leaflet';
import { getTunnelState } from "../../tunnelState/tunnelStateSlice";
import TunnelSignal from "../../tunnelState/TunnelSignal";

const TunnelMarkerPopup = (props) => {
    const dispatch = useDispatch();
    const [timerId, setTimerId] = useState(-1);

    const handleOnOpen = () => {
        handleTunnelStateFetch();
        setTimerId(setInterval(() => handleTunnelStateFetch(), 30 * 1000));
        window.location.hash = props.tunnelId;
    };
    const handleOnClose = () => {
        clearInterval(timerId);
        window.location.hash = '';
    };

    const handleTunnelStateFetch = () => {
        dispatch(getTunnelState());
    };

    return (
        <Popup eventHandlers={{ add: handleOnOpen, remove: handleOnClose }}>
            <TunnelSignal {...props} />
        </Popup>
    );
};

export default TunnelMarkerPopup;
